export enum PetitionGradeProcessStatus {
  Completed = 'completed',
  Pending = 'pending',
}
